import { compose, merge } from 'lodash/fp';

import commonTheme from '@portal/common/theme/theme-config';

export default compose(merge(commonTheme))({
    // local overrides
    // TODO: deprecated to remove after moved to common components
    background: {
        primary: 'linear-gradient(to bottom,#337ab7 0,#265a88 100%)',
        primaryDarker: '#265a88',
        primaryDarkest: '#204d74',
    },
    // TODO: deprecated to remove after moved to common components
    boxShadow: {
        base: 'none',
        baseDarker: 'none',
    },
});
